<template>
  <div class="solution">
    <div class="top item">
        <NovoImg :src="TopImg" :isPage="true"  type="cover"/>
        <!-- <img :src="TopImg" /> -->
        <div class="content-box">
        
          <div class="content">
            <h1>高效管理您的办公空间</h1>
            <p>NOVOBIT智能门禁管理系统满足智能办公空间管理的灵活需求，可以对办公空间公共区域、独立办公室进行人员的权限管理。管理员可通过云端管理平台对门禁显示屏信息进行自定义配置。</p>
            <div class="btn-box">
              <router-link to="/contactus">
                <div class="btn">联系我们</div>
              </router-link>
            </div>
          </div>
        </div>
      
    </div>
    <div class="second item">
      <!-- <img :src="SecondImg"/> -->
      <NovoImg :src="SecondImg" :isPage="true" :isLazy="true" type="cover"/>
        <div class="content-box">
        
          <div class="content">
             <p class="title">会议室管理使用效率提升30%</p>
             <p class="text">将传统的会议室预订升级为更高效的智能会议室预约系统。</p>
          </div>
        </div>
     
    </div>
    <div class="third item">
       <!-- <img :src="ThirdImg"/> -->
      <NovoImg :src="ThirdImg" :isPage="true" :isLazy="true" type="cover"/>

        <div class="content-box">
          <div class="content">
            <p class="title">人员出入权限管理更加灵活</p>
            <p class="text">实时响应，出入无阻</p>
            <p class="text">人员进出信息灵活可追溯</p>
          </div>
        </div>
      
    </div>
    <div class="last item">
      <NovoImg :src="FourthImg" :isPage="true" :isLazy="true" type="cover"/>
        <div class="content-box">
          <div class="content">
            <p class="title">科技感的智能门禁大幅提高公司形象</p>
            <p class="text last-text">打造充满智能、科技、惊艳的产品，为您提供更贴心的管理，更优质的服务。</p>
          </div>
        </div>
      <NovoGotop style="position:absolute;bottom:0;left:50%;margin-left:-21px;"/>
    </div>
    
    <NovoFooter/>
  </div>
</template>

<script>
  import TopImg from 'common/image/solution/first.png';
  import SecondImg from 'common/image/solution/second.png';
  import ThirdImg from 'common/image/solution/third.png';
  import FourthImg from 'common/image/solution/fourth.png';
  import {NovoImg,NovoFooter,NovoGotop} from 'novo-ui';

  export default {
    name: "Solution",
    components: {
      NovoImg,
      NovoFooter,
      NovoGotop
    },
    data() {
      return {
        TopImg,SecondImg,ThirdImg,FourthImg,

      };
    },
    mounted() {

    },
    methods: {


    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  // @import "~common/scss/variable";
  @import "~common/scss/mixin";
  .solution{
    .item{
      position: relative;
      font-size: 0;
      img{
        width:100%;
      }
      .content-box{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        // background: rgba(0,0,0,0.30);
        
      }
      
    }
    .top{
      .content{
          position: absolute;
          width:1060px;
          top: 50%;
          left:50%;
          transform: translate(-50%,-50%);
          color:#fff;
          h1{
            font-family: DFPKingGothicGB-Medium;
            font-size: 36px;
            color: #FFFFFF;
            text-align: center;
            font-weight:500;
            margin-bottom:38px;
          }
          p{
            width: 1060px;
            font-family: DFPKingGothicGB-Regular;
            font-size: 24px;
            color: #FFFFFF;
            text-align: center;
            line-height: 50px;
            margin-bottom:38px;

          }

          @include button();
          .btn-box{
            text-align: center;
            .btn{
              margin: 0 auto;
              width: 180px;
              height: 60px;
              line-height: 60px;
              text-align: center;
              background-image: linear-gradient(-135deg, #7CE1FF 0%, #3CA9FF 100%);
              border-radius: 30px;
              font-family: DFPKingGothicGB-Medium;
              font-size: 24px;
              color: #FFFFFF;
              cursor: pointer;
            }
          }
          
        }
    }
    .second,.third{
      .content{
        position: absolute;
        width:1060px;
        top: 18%;
        left: 50%;
        transform: translate(-50%,0);
        padding-left:40px;
        .title{
          font-family: DFPKingGothicGB-Medium;
          font-size: 32px;
          color: #000000;
          margin-bottom:10px;
          font-weight: 500;
        }
        .text{
          font-family: DFPKingGothicGB-Regular;
          font-size: 24px;
          color: #000000;
          line-height: 46px;
        }
        
      }
    }
    .third{
      .content{
        width:1060px;
        top:58%;
        padding-right:40px;
        .text{
          text-align: right;
          color: #fff;
        }
        .title{
          text-align: right;
          color: #fff;
        }
      }
    }
    .last{
      .content{
        position: absolute;
        width:1060px;
        left: 50%;
        top:15%;
        transform:translate(-50%,0);
        padding-left:40px;
        .title{
          font-family: DFPKingGothicGB-Medium;
          font-size: 32px;
          color: #000000;
          margin-bottom: 10px;
        }
        .text{
          width: 603px;
          font-family: DFPKingGothicGB-Regular;
          font-size: 24px;
          color: #000000;
          line-height: 46px;
        }
        
      }
    }
  }
  



</style>



// WEBPACK FOOTER //
// src/pages/solution/index.vue